module.exports = __webpack_public_path__ + "img/message-templates-icon.3d06ba61.svg";